import firebase from 'firebase';
import 'firebase/firestore';
import GeoFire from 'geofire';


if (process.env.REACT_APP_ENV === 'test') {
  firebase.initializeApp({
    apiKey: 'AIzaSyBV76iiSjuPI__ePu7JxPN0qIn-pvyJwkg',
    authDomain: 'petpate-test.firebaseapp.com',
    databaseURL: 'https://petpate-test.firebaseio.com',
    projectId: 'petpate-test',
    storageBucket: '',
    messagingSenderId: '260977498626'
  });
}

if (process.env.REACT_APP_ENV === 'develop') {
  firebase.initializeApp({
    apiKey: 'AIzaSyDLQb51wrYDOzafwVIDECK4Q73xC-M0utk',
    authDomain: 'petpate-develop.firebaseapp.com',
    databaseURL: 'https://petpate-develop.firebaseio.com',
    projectId: 'petpate-develop',
    storageBucket: 'petpate-develop.appspot.com',
    messagingSenderId: '72155863157'
  });
}

if (process.env.REACT_APP_ENV === 'production') {
  firebase.initializeApp({
    apiKey: 'AIzaSyD7sLevWdf0k_T_qsQnqJsJxcI6hY35U2Q',
    authDomain: 'petpate-production.firebaseapp.com',
    databaseURL: 'https://petpate-production.firebaseio.com',
    projectId: 'petpate-production',
    storageBucket: 'petpate-production.appspot.com',
    messagingSenderId: '700184992651'
  });
}


const firebaseRef = firebase.database().ref();
const geoFire = new GeoFire(firebaseRef);
const db = firebase.firestore();

export { firebase, geoFire, db };



// WEBPACK FOOTER //
// ./src/actions/firebase.js